import SearchForm from './components/SearchForm/SearchFromWidget/SearchFromWidget.css';
export default {
    SearchForm: {
        SearchForm: {
            searchForm: SearchForm.container,
            wrapper: SearchForm.wrapper,
            row: SearchForm.row,
            searchForm_multiCity: SearchForm.searchForm_multiCity
        },
        Segments: {
            segments: SearchForm.segments
        },
        Segment: {
            wrapper: SearchForm.segment__wrapper,
            cell: SearchForm.segment__cell,
            location__value: SearchForm.location__value,
            cell_location: SearchForm.segment__cell_location,
            cell_date: SearchForm.segment__cell_date,
            input: SearchForm.segment__input,
            input_text: SearchForm.segment__input_text,
            withMultiCity: SearchForm.segment_withMultiCity,
            segment: SearchForm.segment,
            control: SearchForm.segment__control
        },
        Passengers: {
            passengers: SearchForm.passengers,
            arrowIcon: SearchForm.passengers__arrowIcon,
            selector: SearchForm.passengers__selector,
            passengers_withCurrency: SearchForm.passengers_withCurrency,
            passengers_isMultiCity: SearchForm.passengers_isMultiCity
        },
        Currency: {
            currency: SearchForm.currency,
            arrowIcon: SearchForm.currency__arrowIcon,
            selector__inner: SearchForm.selector__inner
        },
        MultiCity: {
            caption: SearchForm.multiCity__caption
        },
        Controls: {
            controls: SearchForm.controls
        },
        StartSearch: {
            startSearch: SearchForm.startSearch
        },
        Location: {
            switcher: SearchForm.location__switcher,
            switcher_alternative: SearchForm.switcher_alternative
        },
        Datepicker: {
            date__inputWrapper: SearchForm.date__inputWrapper,
            dates__to: SearchForm.dates__to,
            dates__back: SearchForm.dates__back,
            alternative: SearchForm.alternative,
            dates__to_text: SearchForm.dates__to_text,
            returnDelete: SearchForm.returnDelete
        },
        Actions: {
            addSegment_alternative: SearchForm.addSegment_alternative,
            removeSegment_alternative: SearchForm.removeSegment_alternative
        }
    }
};
